module.exports = __webpack_public_path__ + "static/media/corporate-services-img35.d26f7003.jpg";